import { useState } from "react";
import api from "../utils/apiClient";
import { useAuth } from "../context/AuthContext.js";

function formatStringExp(input) {
  let noSlashes = input.replace(/\//g, "");
  let reversed = noSlashes.split("").reverse().join("");
  return reversed;
}


export default function usePayment() {
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");
  const [comprado, setcomprado] = useState(false);
  const [auctionId, setAuctionIdState] = useState("");
  const [pendingCarAdId, setPendingCarAdIdState] = useState("");
  const [pendingAdSpaceId, setPendingAdSpaceIdState] = useState("");
  const { authToken } = useAuth();
  const paymentsEnabled = process.env.REACT_APP_PAYMENTS_ENABLED !== "false";

  const openPaymentModal = () => {
    if (!paymentsEnabled) {
      setcomprado(true);
      setPaymentSuccess(true);
      setStatusMsg("");
      return;
    }
    setShowPaymentModal(true);
  };
  const closePaymentModal = () => setShowPaymentModal(false);

  const setAuctionId = (id) => {
    setAuctionIdState(id || "");
    setPendingCarAdIdState("");
    setPendingAdSpaceIdState("");
  };

  const setPendingCarAdId = (id) => {
    setPendingCarAdIdState(id || "");
    setAuctionIdState("");
    setPendingAdSpaceIdState("");
  };

  const setPendingAdSpaceId = (id) => {
    setPendingAdSpaceIdState(id || "");
    setPendingCarAdIdState("");
    setAuctionIdState("");
  };

  const confirmPayment = async (data) => {
    if (!paymentsEnabled) {
      setcomprado(true);
      setPaymentSuccess(true);
      setStatusMsg("");
      return;
    }

    if (!authToken) {
      setStatusMsg("Debes iniciar sesión para completar el pago");
      return;
    }

    const amountValue = Number((data.order_amount || "1").replace(/,/g, ""));
    if (!amountValue || Number.isNaN(amountValue)) {
      setStatusMsg("Monto de pago inválido");
      return;
    }

    const referenceId = pendingCarAdId || pendingAdSpaceId || auctionId;

    const payload = {
      customer_name: data.customer_name,
      card_holder: data.card_holder,
      card_number: data.card_number.replace(/\s/g, ""),
      card_expire: formatStringExp(data.card_expire),
      card_cvv: data.card_cvv,
      customer_email: data.customer_email,
      billing_address: data.billing_address,
      billing_city: data.billing_city,
      billing_country: data.billing_country,
      billing_state: data.billing_state,
      billing_phone: data.billing_phone,
      order_id: referenceId || data.order_id || Date.now().toString(),
      order_currency: "HNL",
      order_amount: amountValue.toFixed(2),
      env: process.env.REACT_APP_PIXELPAY_ENV || "sandbox",
      lang: process.env.REACT_APP_PIXELPAY_LANG || "es",
    };

    try {
      const paymentResponse = await api.post("payments/pixelpay", payload);

      if (paymentResponse.status >= 200 && paymentResponse.status < 300) {
        try {
          const transactionPayload = {
            response: paymentResponse.data,
          };

          if (auctionId) {
            transactionPayload.auctionId = auctionId;
          }

          if (pendingCarAdId) {
            transactionPayload.pendingCarAdId = pendingCarAdId;
          }

          if (pendingAdSpaceId) {
            transactionPayload.pendingAdSpaceId = pendingAdSpaceId;
          }

          await api.post("transactions", transactionPayload);
          setcomprado(true);
          closePaymentModal();
          setPaymentSuccess(true);
        } catch (err) {
          console.error(err);
          setStatusMsg("Error registrando transacción");
        }
      } else {
        setStatusMsg("Error procesando el pago");
      }
    } catch (error) {
      console.error(error);
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Error procesando el pago";
      setStatusMsg(errorMessage);
      throw error;
    }
  };

  return {
    showPaymentModal,
    openPaymentModal,
    closePaymentModal,
    confirmPayment,
    paymentSuccess,
    setPaymentSuccess,
    statusMsg,
    setStatusMsg,
    comprado,
    setcomprado,
    auctionId,
    pendingCarAdId,
    setAuctionId,
    setPendingCarAdId,
    pendingAdSpaceId,
    setPendingAdSpaceId,
    paymentsEnabled,
  };
}
